import { render, staticRenderFns } from "./FlightSearchDescription.vue?vue&type=template&id=919066e0&scoped=true&"
import script from "./FlightSearchDescription.vue?vue&type=script&lang=js&"
export * from "./FlightSearchDescription.vue?vue&type=script&lang=js&"
import style0 from "./FlightSearchDescription.vue?vue&type=style&index=0&id=919066e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919066e0",
  null
  
)

export default component.exports